import { supabase } from '@/lib/supabase'
import type { User } from '@supabase/supabase-js'
import posthog from 'posthog-js'
import { create } from 'zustand'

interface AuthState {
  user: User | null
  loading: boolean
  initialize: () => Promise<void>
  signOut: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,

  initialize: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession()
    set({ user: session?.user ?? null, loading: false })

    if (session?.user) {
      posthog.identify(session.user.id)
    }

    supabase.auth.onAuthStateChange((_event, session) => {
      const user = session?.user ?? null
      set({ user })

      if (user) {
        posthog.identify(user.id)
      } else {
        posthog.reset()
      }
    })
  },

  signOut: async () => {
    await supabase.auth.signOut()
    posthog.reset()
    set({ user: null })
  },
}))
